import React, { ChangeEvent } from 'react';

import { type FieldProps, Field } from 'formik';
import { getTranslate, Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import useRenderValidText from '../../../../custom-hooks/useRenderValidText';
import { formikValidate } from '../../../../helpers/validation';
import FormItemLayout from '../../../../ui/Forms/FormItemLayout';
import TextField from '../../../../ui/TextField/TextField';
import { icon } from '../../../WebsiteAndApp/helpers';

const validateNameField = (value: string) => {
  return formikValidate.SMSRestaurantName(value);
};

const tooltipOptions = {
  fdKey: 'Tooltip-SMS-Restaurant-name',
  titleId: 'Name' as TranslationId,
  messageId: 'SMS_Restaurant_name_tooltip' as TranslationId,
};
type InnerProps = MappedProps;
type OuterProps = {};
type Props = InnerProps & OuterProps;
const SmsRestaurantNameField = ({ translate }: Props) => {
  return (
    <FormItemLayout
      label={<Translate id="Restaurant_name" />}
      showTooltip
      tooltipOptions={tooltipOptions}
    >
      <Field name={'SMSRestaurantName'} validate={validateNameField}>
        {({ field, form }: FieldProps) => {
          const { errors, touched, isSubmitting } = form;
          const fieldError = errors[field.name] as string | undefined;
          const showError = !!fieldError && (touched[field.name] as boolean | undefined);
          // eslint-disable-next-line react-hooks/rules-of-hooks -- TODO: pre-existing
          const helperText = useRenderValidText({
            fieldError,
            showError,
            touched: !!touched[field.name],
            value: field.value,
          });

          return (
            <TextField
              value={field.value}
              fdKey={'SMS-Restaurant-name'}
              autoComplete="off"
              fullWidth
              style={{ paddingRight: 16 }}
              placeholder={translate('Enter_name') as string}
              disabled={isSubmitting}
              error={showError}
              helperText={helperText}
              FormHelperTextProps={{
                children: ' ', // reserves line height for error message
                style: { textAlign: 'right' },
              }}
              inputProps={{
                style: {
                  paddingTop: 0,
                  height: '1.1876em',
                },
                maxLength: 11,
              }}
              InputProps={{
                endAdornment: icon(
                  showError,
                  touched[field.name] as boolean,
                  field.value[field.name]
                ),
              }}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                form.setFieldValue(field.name, e.target.value);
              }}
            />
          );
        }}
      </Field>
    </FormItemLayout>
  );
};

type MappedProps = ReturnType<typeof mapStateToProps>;
const mapStateToProps = (state: AppState) => ({
  translate: getTranslate(state.locale),
});
export default compose<InnerProps, OuterProps>(connect(mapStateToProps))(SmsRestaurantNameField);
